import { render, staticRenderFns } from "./Consortium.vue?vue&type=template&id=19f112be&scoped=true&"
import script from "./Consortium.vue?vue&type=script&lang=js&"
export * from "./Consortium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f112be",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/sections/Consortium.vue
// module id = 547
// module chunks = 0